var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ShareNetwork', {
    style: {
      backgroundColor: _vm.sharing.color,
      margin: '0.2rem',
      padding: '0.4rem 0.5rem',
      borderRadius: '20%'
    },
    attrs: {
      "network": _vm.sharing.network,
      "title": _vm.sharing.title,
      "url": _vm.sharing.url,
      "quote": _vm.sharing.quote,
      "hashtags": _vm.sharing.hashtags
    }
  }, [_c('b-icon', {
    attrs: {
      "variant": "white",
      "icon": _vm.sharing.icon,
      "scale": "1.4"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }